import { getConnector } from '../services/PatientFacingClient';
import { RootDispatch, RootState } from '../store';
import { trackMessageViewed } from '../services/Tracker';

export interface ConversationState {
  counterPartyId: string;
  disableCompose: boolean;
  id: string;
  lastModified: string;
  members: any[];
  organizationId: string;
}

const initialState: ConversationState = {
  counterPartyId: '',
  disableCompose: false,
  id: '',
  lastModified: '',
  members: [],
  organizationId: '',
};

export const conversation = {
  effects: (dispatch: RootDispatch) => ({
    deleteConversation(conversation: any, rootState: RootState) {
      if (conversation.id === rootState.conversation.id) {
        dispatch.currentPage.showInvalid();
      }
    },
    setConversation(conversation: any) {
      dispatch.conversation.update({
        counterPartyId: conversation.counterPartyId,
        disableCompose: !!conversation?.counterParty?.patientDetails?.smsOptedOut,
        id: conversation.id,
        lastModified: conversation.lastModified,
        organizationId: conversation.organizationId,
        members: conversation.counterParty.memberIds,
      });
    },
    updateConversation(conversation: any, rootState: RootState) {
      if (conversation.id === rootState.conversation.id) {
        dispatch.conversation.update({
          counterPartyId: conversation.counterPartyId,
          disableCompose: !!conversation?.counterParty?.patientDetails?.smsOptedOut,
          id: conversation.id,
          lastModified: conversation.lastModified,
          organizationId: conversation.organizationId,
          members: conversation.counterParty.memberIds,
        });
      }
    },
    addMember(members: any[]) {
      const { client } = getConnector();
      client.models.User.inject(members[0]);
      return;
    },

    async markConversationAsRead(_payload: boolean, rootState: RootState) {
      const { client } = getConnector();
      const sdkConv = client.conversations.getById(rootState.conversation.id);
      const shouldMark = sdkConv.unreadCount > 0;
      const unreadCount = sdkConv.unreadCount;
      if (shouldMark) {
        await client.conversations.markAsRead(rootState.conversation.id);
        for (let i = 0; i < unreadCount; i++) {
          trackMessageViewed();
        }
      } else {
        return;
      }
    },
    startTyping(_payload: any, rootState: RootState) {
      const { client } = getConnector();
      client.typingStatus.startTyping(rootState.conversation.counterPartyId, {
        organizationId: rootState.conversation.organizationId,
      });
    },
  }),
  reducers: {
    update: (
      state: ConversationState,
      {
        counterPartyId,
        disableCompose,
        id,
        lastModified,
        members,
        organizationId,
      }: ConversationState
    ): ConversationState =>
      Object.assign({}, state, {
        counterPartyId,
        disableCompose,
        id,
        lastModified,
        members,
        organizationId,
      }),
  },
  state: initialState,
};
